import React from 'react';
import { Box, Typography } from '@mui/material';

const Home: React.FC = () => (
  <Box
    sx={{
      backgroundColor: 'white',
      minHeight: '80vh',
      color: 'rgb(79,111,82)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      py: 4
    }}
  >
    <Box
      component="img"
      src="/logo192.png"
      alt="Handprint Logo"
      sx={{ height: 80, mb: 2 }}
    />
    <Typography variant="h3" sx={{ fontWeight: 700 }}>
      Handprint API Demo
    </Typography>
    <Typography variant="h6" sx={{ mt: 2, mb: 4, maxWidth: 600 }}>
      Explore regenerative solutions—use the menu to get started.
    </Typography>
  </Box>
);

export default Home;
